import { TableField } from "@/types/table-field";

const codigoBanco: TableField = {
    key: "codigoBanco",
    label: "Código do Banco",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
}
const codigoAgencia: TableField = {
    key: "codigoAgencia",
    label: "Código da Agência",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
}
const numeroContBancaria: TableField = {
    key: "numeroContBancaria",
    label: "Nº da Conta Bancária",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
}
const dsConta: TableField = {
    key: "descricaoContBancaria",
    label: "Descrição",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    sortable: true,
}
const dsTipoConta: TableField = {
    key: "descricaoTipoContBancaria",
    label: "Tipo da Conta",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    sortable: true,
}
const flInativo: TableField = {
    key: "flInativo",
    label: "Situação",
    tdClass: ["align-middle", "text-center"],
    thClass: ["text-center"],
    sortable: true,
}
const actions: TableField = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: "text-center",
    sortable: false,
}

export const fieldsContasInativar: TableField[] = [
    codigoBanco,
    codigoAgencia,
    numeroContBancaria,
    dsConta,
    dsTipoConta,
    flInativo,
    actions
]
